import { Button, Col, ConfigProvider, Row, Spin, Tabs, TabsProps, Typography } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import ReportTable from "./ReportTable";
import { useShallow } from "zustand/react/shallow";
import { profileStore } from "src/stores/profile-store";
import { FlareCaseEnum } from "src/entity/flare/flare.constants";
import { EmissionObjectEnum, UnitAllEnum } from "src/entity/common/unit.constant";
import "./ReportTable.css";
import { componentPalette } from "src/theme/component-palette";
import { EnumReportScope } from "src/entity/main-report/main-report.entity";
import { mainReportStore } from "src/stores/main-report-store";
import dayjs, { Dayjs } from "dayjs";
import { COMPANY_GROUP, DROPDOWN_COMPANY_LISTS, SCGC_JV, SCGC_Subsidiary } from "src/entity/common/common.constant";
import { convertLastThreeDecimalToZero } from "src/utils/number";
import { companyStore } from "src/stores/company-store";
import { useDidMount } from "src/hook/useDidMount";
import { RolesNameEnum } from "src/entity/common/roles.enum";

const { Text, Title } = Typography;

interface ReportComponentProps {}

const ReportComponent: React.FC<ReportComponentProps> = ({}) => {
  const currentYear = new Date().getFullYear();

  const profile = profileStore(useShallow((state) => state.profile));
  const company = profile?.company ?? [];
  const activeCompany = profile?.activeCompany._id as string;

  const loadingOverviews = mainReportStore(useShallow((state) => state.loadingOverviews));
  const dataOverviews = mainReportStore(useShallow((state) => state.dataOverviews));

  const getDistinctYearDropdown = mainReportStore(useShallow((state) => state.getDistinctYearDropdown));
  const dataDistinctYear = mainReportStore(useShallow((state) => state.dataDistinctYear));

  const [selectedButton, setSelectedButton] = useState("table");
  const [selectedYear, setSelectedYear] = useState<string[]>([currentYear.toString()]);
  const [rangeYear, setRangeYear] = useState<[Dayjs, Dayjs]>([dayjs(new Date()), dayjs(new Date())]);
  const [selectedCompany, setSelectedCompany] = useState<string>("");
  const [selectedEmission, setSelectedEmission] = useState<string>(EmissionObjectEnum.TVOC);
  const [selectedCase, setSelectedCase] = useState<string[]>([FlareCaseEnum.NORMAL_OPERATE]);
  const [selectedUnit, setSelectedUnit] = useState<UnitAllEnum>(UnitAllEnum.KG);
  const [scope, setScope] = useState<EnumReportScope>(EnumReportScope.MONTHLY);

  const searchMappingCompany = companyStore(useShallow((state) => state.searchMappingCompany));
  const dataMapCompany = companyStore(useShallow((state) => state.dataMapCompany));

  useDidMount(() => {
    searchMappingCompany({});
  });

  const initStaticMaster = () => {
    if (!dataDistinctYear.length) getDistinctYearDropdown();
  };
  useEffect(() => {
    initStaticMaster();
  }, []);

  const optionDropdownCompany = useMemo(() => {
    if (company.length) {
      // SCGC All , SCGC Subsidiary , SCGC JV
      // console.log("[ALL] companies : ", company);
      const isSystemAdmin = profile?.roles.includes(RolesNameEnum.SYSTEM_ADMIN);
      // let options: { label: string; value: string }[] = [];
      const options = company
        .filter((base) => DROPDOWN_COMPANY_LISTS.includes(base.companyName.toUpperCase()))
        .map((item) => ({
          label: item.companyName,
          value: item._id,
        }));

      // ต้องเพิิ่ม Logic การ check company ที่ active

      const allCompanyString = company
        .filter((item) => {
          const mathCompany = dataMapCompany.find((mapCompany) => String(mapCompany.company.companyName) === item.companyName);
          return mathCompany?.reportVisible?.find((report) => report.companyGroup === COMPANY_GROUP.SCGC_ALL && report.isActive);
        })
        .map((item) => item._id)
        .join(",");
      const subsidiary = company
        .filter((item) => SCGC_Subsidiary.includes(item.companyName))
        .filter((item) => {
          const mathCompany = dataMapCompany.find((mapCompany) => String(mapCompany.company.companyName) === item.companyName);
          return mathCompany?.reportVisible?.find((report) => report.companyGroup === COMPANY_GROUP.SCGC_SUBSIDIARY && report.isActive);
        })
        .map((item) => item._id)
        .join(",");
      const jv = company
        .filter((item) => SCGC_JV.includes(item.companyName))
        .filter((item) => {
          const mathCompany = dataMapCompany.find((mapCompany) => String(mapCompany.company.companyName) === item.companyName);
          return mathCompany?.reportVisible?.find((report) => report.companyGroup === COMPANY_GROUP.SCGC_JV && report.isActive);
        })
        .map((item) => item._id)
        .join(",");

      if (isSystemAdmin) {
        options.unshift(
          { label: COMPANY_GROUP.SCGC_ALL, value: allCompanyString },
          { label: COMPANY_GROUP.SCGC_SUBSIDIARY, value: subsidiary },
          { label: COMPANY_GROUP.SCGC_JV, value: jv },
        );
      }

      options.forEach((item) => {
        item.value = `${item.label}:${item.value}`;
      });

      // options.unshift({ label: "All", value: company.map((e) => e._id).join(",") });
      return options;
    }

    return [];
  }, [profile?.company, profile?.activeCompany]);

  useEffect(() => {
    if (optionDropdownCompany.length) {
      setSelectedCompany(optionDropdownCompany[0]?.value || "");
      // const findSlot = optionDropdownCompany.find((item) => item.label === COMPANY_GROUP.SCGC_ALL);
      // setSelectedCompany(findSlot?.value as string);
      // setSelectedCompany(optionDropdownCompany[0].value);
    }
  }, [optionDropdownCompany]);

  const optionDropdownYears = useMemo(() => {
    if (dataDistinctYear.length) {
      const options = dataDistinctYear.map((item) => ({
        label: item,
        value: item,
      }));
      // options.unshift({ label: "All", value: dataDistinctYear.join(",") });
      return options;
    }

    return [];
  }, [dataDistinctYear]);

  const tableChildrenTab = () => {
    return (
      <ReportTable
        selectedButton={selectedButton}
        setSelectedButton={setSelectedButton}
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
        selectedCompany={selectedCompany}
        setSelectedCompany={setSelectedCompany}
        selectedEmission={selectedEmission}
        setSelectedEmission={setSelectedEmission}
        selectedCase={selectedCase}
        setSelectedCase={setSelectedCase}
        scope={scope}
        optionDropdownCompany={optionDropdownCompany}
        selectedUnit={selectedUnit}
        setSelectedUnit={setSelectedUnit}
        rangeYear={rangeYear}
        setRangeYear={setRangeYear}
        optionDropdownYears={optionDropdownYears}
      />
    );
  };

  const items = [
    {
      key: EnumReportScope.MONTHLY,
      label: "Monthly",
    },
    {
      key: EnumReportScope.YEARLY,
      label: "Yearly",
    },
  ];

  const onChangeScope = (key: EnumReportScope) => {
    setSelectedYear([currentYear.toString()]);
    setRangeYear([dayjs(new Date()), dayjs(new Date())]);
    setScope(key);
  };

  // console.log("dataOverviews ::: ", dataOverviews);
  return (
    <div className="w-full" id={"wrap-root-main-report"}>
      <Row className="w-full bg-white rounded">
        <Row className="w-full p-4">
          <Col span={24}>
            {/* <Text>Normal Case Include Only Subsidiary Companies​</Text> */}
            <Row className="w-full pt-2" justify={"space-between"} gutter={[6, 0]} align={"middle"}>
              <Col xs={24} sm={12} md={5}>
                {loadingOverviews ? (
                  <Spin spinning />
                ) : (
                  <div className="text-center">
                    <Title level={5}>VOCs Intensity Target (2030)</Title>
                    <Title level={3}>{dataOverviews.vocsIntensityTarget2030}</Title>
                    <Text>g/Ton</Text>
                  </div>
                )}
              </Col>
              <Col xs={24} sm={12} md={5}>
                {loadingOverviews ? (
                  <Spin spinning />
                ) : (
                  <div className="text-center">
                    <Title level={5}>Annual VOCs Target</Title>
                    <Title level={3}>{scope === EnumReportScope.YEARLY ? "-" : dataOverviews.annualVocsTarget}</Title>
                    <Text>g/Ton</Text>
                  </div>
                )}
              </Col>
              <Col xs={24} sm={12} md={5}>
                {loadingOverviews ? (
                  <Spin spinning />
                ) : (
                  <div className="text-center">
                    <Title level={5}>VOCs Intensity</Title>
                    <Title level={3}>{scope === EnumReportScope.YEARLY ? "-" : dataOverviews.vocsIntensity}</Title>
                    <Text>g/Ton</Text>
                  </div>
                )}
              </Col>
              <Col xs={24} sm={12} md={5}>
                {loadingOverviews ? (
                  <Spin spinning />
                ) : (
                  <div className="text-center">
                    <Title level={5}>VOCs Emission</Title>
                    <Title level={3}>{scope === EnumReportScope.YEARLY ? "-" : dataOverviews.vocsEmission}</Title>
                    <Text>Kg</Text>
                  </div>
                )}
              </Col>
            </Row>
          </Col>
        </Row>
      </Row>

      <Row className="w-full bg-red pt-4" id={"report-group"}>
        {items.map((item, index) => {
          return (
            <Button
              key={index}
              type={"default"}
              className="bg-transparent border border-transparent"
              style={{
                borderRadius: 0,
                color: scope === item.key ? componentPalette.primary : "",
                borderBottom: scope === item.key ? `2px solid ${componentPalette.primary}` : "",
              }}
              onClick={() => onChangeScope(item.key)}
            >
              {item.label}
            </Button>
          );
        })}
      </Row>

      {!optionDropdownCompany || !optionDropdownCompany.length || !selectedCompany ? <Spin spinning></Spin> : tableChildrenTab()}
    </div>
  );
};

export default ReportComponent;
